<template>
  <div :class="$b()">
    <wistia-player :video-id="videoId" />
    <h2 :class="$b('title')" class="h2">
      {{ $ts('login_page.video.claim') }}
    </h2>
    <rating-mark />
    <div :class="$b('actions')">
      <a class="btn btn-lg btn-light" :href="detailsLink">
        {{ $ts('testimonials.details.button') }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { DpButton } from '@dp-ui-kit/vue';

import { INFO_LINKS_MAP, VIDEO_IDS_MAP } from '@/modules/authentication/ui/config';
import RatingMark from '@/modules/authentication/ui/components/RatingMark.vue';
import WistiaPlayer from '@/modules/authentication/ui/components/WistiaPlayer.vue';
import { localeDetector } from '@/modules/authentication/ui/container';
import type { Locale } from '@/modules/authentication/domain/LocaleDetector';

@Component({
  name: 'VideoSection',
  components: { DpButton, RatingMark, WistiaPlayer },
})
export default class VideoSection extends Vue {
  get detailsLink(): string {
    return INFO_LINKS_MAP[this.domainLocale] ?? INFO_LINKS_MAP.fallback;
  }

  get videoId(): string {
    return VIDEO_IDS_MAP[this.domainLocale] ?? VIDEO_IDS_MAP.fallback;
  }

  get domainLocale(): Locale {
    return localeDetector().getBasedOnDomain().locale;
  }
}
</script>

<style lang="scss" scoped>
@use 'src/assets/scss/variables' as v;
.dp-video-section {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: v.$spacer-md * 2;

  &__title {
    max-width: 30ch;
    margin: 0;
    color: v.$midnight-blue;
    font-weight: v.$font-weight-medium;
  }
}
</style>
